import { Link } from "@tanstack/react-router";
import { BookHeart } from "lucide-react";

import { QueueRow, QueueSection } from "@/components/medico/queue-section";
import { EmptyState } from "@/components/ui/empty-state";
import { SkeletonRows } from "@/components/ui/skeleton";
import { useManualDrafts } from "@/hooks/use-manuals";
import { ManualLabels } from "@/lib/labels/manuals";
import { format } from "@/lib/format";

export function DraftsList() {
	const drafts = useManualDrafts();

	if (drafts.data === undefined) {
		return <SkeletonRows rows={3} />;
	}

	const subtitle =
		drafts.data.length > 0 ? ManualLabels.drafts.count(drafts.data.length) : undefined;

	return (
		<QueueSection title={ManualLabels.drafts.title} subtitle={subtitle}>
			{drafts.data.length === 0 && (
				<EmptyState icon={BookHeart} title={ManualLabels.drafts.emptyTitle} />
			)}

			{drafts.data.map((draft) => (
				<QueueRow key={draft.id}>
					<div className="flex items-center gap-2">
						<Link
							to="/clinica/manual/$id"
							params={{ id: draft.id }}
							className="min-w-0 flex-1 truncate text-sm font-medium text-primary transition-colors hover:text-primary-hover focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
						>
							{draft.name}
						</Link>

						<span className="shrink-0 font-mono text-xs text-muted-foreground">
							{format.dateTime(draft.updatedAt)}
						</span>
					</div>
				</QueueRow>
			))}
		</QueueSection>
	);
}
